module.exports = __webpack_public_path__ + "img/钟表-1.d365197c.png";